// Diwali layer: cute firecracker Lottie characters living in the existing pages' white space.
// Nothing is rewritten; elements are added around the current sections. Off with ?diwali=off.
// Animations play only while on screen; "reduce motion" shows still frames and skips the rocket flight.
(function(){
  if (/[?&]diwali=off/.test(location.search)) return;
  if (window.HG_LANG === 'de') return;
  var RM = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var CUT = Date.parse('2026-10-28T23:59:00+05:30'); // last order date for delivery before Diwali (to confirm)
  var BASE = window.HG_ASSET || '';
  var LIB = BASE ? BASE + 'lottie_light.min.js' : 'https://cdnjs.cloudflare.com/ajax/libs/lottie-web/5.12.2/lottie_light.min.js';
  var URL_ = window.HG_URL || {};
  var link = function(s){ return URL_[s] || '/products/' + s };
  var DIYA = '<svg class="dw-diya" viewBox="0 0 24 24" aria-hidden="true"><path d="M2.5 13.5h19c-1 4.2-5 6.5-9.5 6.5s-8.5-2.3-9.5-6.5z" fill="#E9B44C"/><path class="dw-fl" d="M12 2.5c2.4 3.2 2.8 5.6 0 8.6-2.8-3-2.4-5.4 0-8.6z" fill="#F29F1D"/><path class="dw-fl" d="M12 5.5c1.1 1.6 1.2 2.9 0 4.4-1.2-1.5-1.1-2.8 0-4.4z" fill="#FFE6A8"/></svg>';

  var css = [
    '.dw-diya{width:1.25em;height:1.25em;vertical-align:-.28em;margin-right:.45em;flex:none}',
    '.dw-fl{transform-origin:12px 11px;animation:dwFlick 1.6s ease-in-out infinite}',
    '@keyframes dwFlick{0%,100%{transform:none}30%{transform:scale(.88,1.08) rotate(-3deg)}60%{transform:scale(1.05,.94) rotate(2deg)}}',
    '.bar{color:#F6D58A}',
    '.dw-l svg{display:block}',
    // "Light one up": the cracker stage
    '.dw-lu{background:#fff;padding:44px 0 40px;overflow:hidden}',
    '.dw-lu .h-wrap{display:grid;gap:22px}',
    '.dw-lu h2{font:300 clamp(34px,9vw,54px)/1.02 var(--sans);letter-spacing:-.015em;color:var(--ink);margin:0}',
    '.dw-lu h2 i{font-style:italic;font-weight:300}',
    '.dw-lu .sub{font:400 14px/1.5 var(--sans);color:var(--ink);opacity:.72;max-width:34ch;margin:10px 0 0}',
    '.dw-stage{display:grid;grid-template-columns:repeat(3,1fr);align-items:end;gap:6px;position:relative;padding:120px 0 2px;margin:-40px 0 30px}',
    '.dw-ck{all:unset;cursor:pointer;display:flex;flex-direction:column;align-items:center;gap:8px;-webkit-tap-highlight-color:transparent;position:relative;z-index:1}',
    '.dw-ck .dw-l{width:100%;transform:scale(var(--z,2.1));transform-origin:50% 100%;transition:transform .35s cubic-bezier(.2,.75,.34,.94)}',
    '.dw-ck:active .dw-l{transform:scale(calc(var(--z,2.1) * .95))}',
    '.dw-ck[data-k="anaar"] .dw-l{aspect-ratio:240/300}',
    '.dw-ck[data-k="chakri"] .dw-l{aspect-ratio:220/220;--z:1.55}',
    '.dw-ck[data-k="rocket"] .dw-l{aspect-ratio:220/340;--z:1.85}',
    '.dw-ck span{position:relative;z-index:1;margin-top:22px;font:500 10px/1.3 var(--sans);letter-spacing:.18em;text-transform:uppercase;text-align:center;color:var(--ink);background:#fff;box-shadow:0 0 0 1px rgba(58,27,51,.12);padding:7px 10px;border-radius:99px;transition:background .25s,box-shadow .25s}',
    '.dw-ck[aria-pressed="true"] span{background:#FFF1D2;box-shadow:0 0 0 1px #E9B44C}',
    '.dw-ck:focus-visible span{outline:2px solid #E9B44C;outline-offset:2px}',
    '.dw-pickc{display:grid;grid-template-columns:76px 1fr auto;gap:14px;align-items:center;text-decoration:none;color:var(--ink)}',
    '.dw-pickc img{width:76px;height:96px;object-fit:cover;object-position:50% 20%;border-radius:8px;background:var(--sand)}',
    '.dw-pickc small{display:block;font:400 12px var(--sans);opacity:.6}',
    '.dw-pickc b{display:block;font:400 17px/1.25 var(--sans);margin:3px 0}',
    '.dw-pickc em{font:400 13px var(--sans);font-style:normal}',
    '.dw-pickc .go{font:500 11px var(--sans);letter-spacing:.18em;text-transform:uppercase;border-bottom:1px solid currentColor;padding-bottom:3px;white-space:nowrap}',
    '.dw-pickc.sw{animation:dwIn .45s cubic-bezier(.2,.75,.34,.94)}',
    '@keyframes dwIn{from{opacity:0;transform:translateY(8px)}}',
    '@media(min-width:760px){.dw-stage{max-width:620px;justify-self:end;width:100%}.dw-ck .dw-l{--z:1.25!important}.dw-ck[data-k="chakri"] .dw-l{--z:1!important}.dw-ck[data-k="rocket"] .dw-l{--z:1.1!important}}',
    '@media(min-width:760px){.dw-lu{padding:72px 0 64px}.dw-lu .h-wrap{grid-template-columns:1fr 1.25fr;align-items:end;column-gap:56px}.dw-stage{grid-row:span 2}.dw-pickc{align-self:start}}',
    // fireworks in the empty middle of section headers
    '.hhd .dw-fw{flex:0 1 150px;aspect-ratio:320/200;margin:0 auto -6px;pointer-events:none;align-self:center}',
    // diyas over the newsletter
    '.dw-diyas{display:flex;gap:4px;margin:0 0 14px;height:58px}',
    '.dw-diyas .dw-l{width:46px;aspect-ratio:120/130}',
    // product page
    '.dw-dl{display:grid;grid-template-columns:44px 1fr;gap:10px;align-items:center;margin:16px 0 20px;padding:8px 13px 8px 6px;border:1px solid rgba(233,180,76,.6);border-radius:10px;background:#FFFBF2;font:400 12.5px/1.4 var(--sans);color:var(--ink)}',
    '.dw-dl .dw-l{width:44px;aspect-ratio:240/300;margin-top:-14px;transform:scale(2);transform-origin:50% 80%}',
    '.dw-dl b{font-weight:500}',
    '.dw-dl .c{font-variant-numeric:tabular-nums;color:#8A6416;font-weight:500}',
    '.dw-wu{margin:14px 0 2px}',
    '.dw-wu p{font:400 10.5px var(--sans);letter-spacing:.2em;text-transform:uppercase;color:var(--ink);margin:0 0 8px}',
    '.dw-wu div{display:flex;flex-wrap:wrap;gap:6px}',
    '.dw-wu span{font:400 12px var(--sans);padding:6px 12px;border-radius:99px;background:#FFF6E6;border:1px solid #EBCF94;color:var(--ink)}',
    '.hgc-card{position:relative}',
    '.dw-hgc{position:absolute;top:-34px;left:50%;margin-left:-34px;width:68px;aspect-ratio:1;pointer-events:none}',
    '.dw-fly{position:fixed;left:0;top:0;width:36px;aspect-ratio:80/130;pointer-events:none;z-index:2147483600;will-change:transform}',
    '.dw-pop{position:fixed;width:120px;aspect-ratio:1;pointer-events:none;z-index:2147483601;margin:-60px 0 0 -60px}',
    '.fpi,.gwrap{position:relative}',
    '.dw-pick{position:absolute;left:8px;top:8px;z-index:3;display:flex;align-items:center;background:rgba(255,255,255,.94);color:#3A1B33;font:500 9px var(--sans);letter-spacing:.16em;text-transform:uppercase;padding:5px 8px 5px 6px;border-radius:3px;box-shadow:0 0 0 1px rgba(233,180,76,.55)}',
    '.dw-pick .dw-diya{margin-right:.35em}',
    '@media (prefers-reduced-motion:reduce){.dw-fl,.dw-pickc.sw{animation:none!important}}'
  ].join('\n');
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  // ---- Lottie plumbing: one library load, cached JSON, play only while visible
  var libP, data = {};
  function lib(){ return libP || (libP = new Promise(function(ok, no){ if (window.lottie) return ok(window.lottie); var s = document.createElement('script'); s.src = LIB; s.async = true; s.onload = function(){ ok(window.lottie) }; s.onerror = no; document.head.appendChild(s); })); }
  function json(n){ return data[n] || (data[n] = fetch(BASE + 'dw-' + n + '.json').then(function(r){ return r.json() })); }
  // seg: [a, b] to loop; still: frame to show with reduced motion; auto: play when visible
  function mount(el, n, o){
    o = o || {};
    return Promise.all([lib(), json(n)]).then(function(r){
      var a = r[0].loadAnimation({container: el, renderer: 'svg', loop: o.loop !== false, autoplay: false, animationData: JSON.parse(JSON.stringify(r[1])), rendererSettings: {preserveAspectRatio: 'xMidYMid meet'}});
      a.setSubframe(false); // the files are 30fps; don't redraw them at 60
      a.dwSeg = o.seg;
      if (RM){ a.goToAndStop(o.still != null ? o.still : 0, true); return a; }
      if (o.auto !== false){
        var vis = false;
        new IntersectionObserver(function(es){ vis = es[0].isIntersecting; if (!vis) return a.pause(); if (a.dwSeg && !a.dwOn){ a.dwOn = 1; a.playSegments(a.dwSeg, true); } else a.play(); }, {rootMargin: '60px'}).observe(el);
      }
      return a;
    });
  }
  function seg(a, s, loop){ if (RM) return; a.loop = loop; a.dwSeg = s; a.dwOn = 1; a.playSegments(s, true); }

  function run(){
    var $ = function(s, r){ return (r || document).querySelector(s) }, $$ = function(s, r){ return [].slice.call((r || document).querySelectorAll(s)) };
    var slug = Object.keys(URL_).filter(function(k){ return decodeURIComponent(URL_[k]) === decodeURIComponent(location.pathname) })[0] || '';

    // announcement bar: diyas and the Diwali delivery line in both halves of the marquee
    var tr = $('.bar .tr');
    if (tr){
      var sp = $$('span', tr), half = sp.length / 2;
      sp.forEach(function(s){ s.insertAdjacentHTML('afterbegin', DIYA) });
      [sp[0], sp[half]].forEach(function(s){ if (s) s.insertAdjacentHTML('beforebegin', '<span>' + DIYA + 'Order by 28 Oct for Diwali delivery</span>') });
    }

    // ---------------- homepage
    var best = $('#bestsellers');
    if (best){
      var P = {
        anaar: {o: 'Saree', t: 'Shapewear Bodysuit, Liposculpt Microfiber', p: '₹2,560', img: 'img3d--bodysuit-black.jpg', s: 'shapewear-bodysuit'},
        chakri: {o: 'Lehenga', t: 'High Waist Sculpting Shorts', p: '₹2,390', img: 'img3d--combo-hw.jpg', s: 'high-waist-sculpting-shorts'},
        rocket: {o: 'Backless blouse', t: 'Hourglass Body Tape', p: '₹1,100', img: 'img3d--tape.jpg', s: 'body-tape'}
      };
      var sec = document.createElement('section'); sec.className = 'dw-lu';
      sec.innerHTML = '<div class="h-wrap"><div><h2>Light one up.</h2><p class="sub">Every cracker hides the piece that goes under your Diwali outfit. Tap one.</p></div>' +
        '<div class="dw-stage">' + Object.keys(P).map(function(k){ return '<button class="dw-ck" data-k="' + k + '" aria-pressed="false" aria-label="Light the ' + k + ': ' + P[k].o + '"><div class="dw-l"></div><span>' + P[k].o + '</span></button>' }).join('') + '</div>' +
        '<a class="dw-pickc" href="#"></a></div>';
      best.parentNode.insertBefore(sec, best);
      var card = $('.dw-pickc', sec), A = {}, cur = null;
      function show(k){
        var p = P[k];
        card.href = link(p.s);
        card.innerHTML = '<img src="' + BASE + p.img + '" alt="" loading="lazy"><div><small>For your ' + p.o.toLowerCase() + '</small><b>' + p.t + '</b><em>' + p.p + '</em></div><span class="go">Shop</span>';
        card.classList.remove('sw'); void card.offsetWidth; card.classList.add('sw');
      }
      function light(k){
        $$('.dw-ck', sec).forEach(function(b){ b.setAttribute('aria-pressed', b.dataset.k === k) });
        if (cur && cur !== k && A[cur]) seg(A[cur], [0, 60], true);
        cur = k; show(k);
        var a = A[k]; if (!a) return;
        if (k === 'rocket'){ seg(a, [60, 150], false); a.addEventListener('complete', function f(){ a.removeEventListener('complete', f); if (cur === 'rocket') seg(a, [0, 60], true); }); }
        else seg(a, k === 'anaar' ? [60, 180] : [60, 120], true);
      }
      $$('.dw-ck', sec).forEach(function(b){
        var k = b.dataset.k;
        mount($('.dw-l', b), k, {seg: [0, 60], still: k === 'rocket' ? 0 : 110}).then(function(a){ A[k] = a; });
        b.addEventListener('click', function(){ light(k) });
      });
      show('anaar');
      // the first cracker lights itself when the section comes into view
      new IntersectionObserver(function(es, ob){ if (es[0].isIntersecting){ ob.disconnect(); setTimeout(function(){ if (!cur) light('anaar') }, 450); } }, {threshold: .45}).observe(sec);

      $$('.fp', best).slice(0, 4).forEach(function(fp){ var i = $('.fpi', fp); if (i) i.insertAdjacentHTML('beforeend', '<span class="dw-pick">' + DIYA + 'Diwali pick</span>') });
    }

    // a row of diyas that light one after another above the newsletter
    var nl = $('.hf .nl');
    if (nl){
      var row = document.createElement('div'); row.className = 'dw-diyas'; row.setAttribute('aria-hidden', 'true');
      for (var i = 0; i < 5; i++) row.insertAdjacentHTML('beforeend', '<div class="dw-l"></div>');
      nl.insertBefore(row, nl.firstChild);
      Promise.all($$('.dw-l', row).map(function(el){ return mount(el, 'diya', {auto: false, still: 60}) })).then(function(as){
        if (RM) return;
        as.forEach(function(a){ a.goToAndStop(0, true) });
        new IntersectionObserver(function(es, ob){
          if (!es[0].isIntersecting) return; ob.disconnect();
          as.forEach(function(a, i){ setTimeout(function(){ a.loop = false; a.playSegments([24, 46], true); a.addEventListener('complete', function f(){ a.removeEventListener('complete', f); seg(a, [46, 106], true); }); }, 380 * i); });
        }, {threshold: .6}).observe(row);
      });
    }

    // ---------------- product page
    var info = $('.info'), add = $('#add');
    if (info && add){
      var g = $('.gwrap');
      if (g && ['shapewear-bodysuit','high-waist-sculpting-shorts','cloud-compression-full-body-shaping-bodysuit','power-shaper-lower-body','crew-neck-shapewear-bodysuit','body-tape'].indexOf(slug) > -1)
        g.insertAdjacentHTML('beforeend', '<span class="dw-pick">' + DIYA + 'Diwali pick</span>');
      var hr = $('.hr', info);
      if (hr){
        var dl = document.createElement('div'); dl.className = 'dw-dl';
        dl.innerHTML = '<div class="dw-l"></div><div class="tx"></div>';
        hr.parentNode.insertBefore(dl, hr);
        mount($('.dw-l', dl), 'anaar', {seg: [60, 180], still: 110});
        (function tick(){
          var ms = CUT - Date.now(), tx = $('.tx', dl);
          if (ms <= 0){ tx.innerHTML = '<b>₹150 off your first order</b><br>Use code <span class="c">DIWALI</span> at checkout'; return; }
          var d = Math.floor(ms / 864e5), h = Math.floor(ms / 36e5) % 24, m = Math.floor(ms / 6e4) % 60;
          tx.innerHTML = '<b>Arrives before Diwali</b><br>Order in the next <span class="c">' + (d ? d + 'd ' : '') + h + 'h ' + m + 'm</span>';
          setTimeout(tick, 30000);
        })();
      }
      var W = {
        'shapewear-bodysuit':['Saree','Lehenga','Bodycon','Gown'], 'crew-neck-shapewear-bodysuit':['Kurta','Bodycon','Co-ord set'],
        'turtleneck-shapewear-bodysuit':['Fitted kurta','Bodycon','Jumpsuit'], 'tank-top-shapewear-bodysuit':['Saree','Kurta set','Bodycon'],
        'seamless-strapless-bandeau-bodysuit':['Off-shoulder blouse','Strapless gown','Tube dress'], 'cloud-compression-full-body-shaping-bodysuit':['Saree','Anarkali','Bodycon'],
        'full-body-sculpt-lift':['Bodycon','Saree gown','Sharara'], 'buttersculpt-seamless-shapewear-tee':['Kurta','Co-ord set','Fitted top'],
        'high-waist-sculpting-shorts':['Lehenga','Saree','Anarkali'], 'low-waist-sculpting-shorts':['Lehenga','Sharara','Bodycon'],
        'low-waist-lace-sculpting-shorts':['Lehenga','Sharara','Dress'], 'targeted-compression-waist-shaper-shorts':['Saree','Lehenga','Gown'],
        'power-shaper-lower-body':['Saree','Lehenga','Bodycon'], 'high-waist-hollow-butt-lifter':['Lehenga','Sharara','Bodycon'],
        'high-waist-shapewear-thong-panties':['Bodycon','Satin saree','Slip dress'], 'body-tape':['Backless blouse','Deep-neck blouse','Strapless gown']
      }[slug];
      var anchor = $('.unsure', info) || $('#hint', info);
      if (W && anchor) anchor.insertAdjacentHTML('afterend', '<div class="dw-wu"><p>Wear it under</p><div>' + W.map(function(w){ return '<span>' + w + '</span>' }).join('') + '</div></div>');

      var hgc = $('.hgc-card');
      if (hgc){ var ey = $('.hgc-eyebrow', hgc); if (ey) ey.textContent = 'The Diwali Duo'; var ch = document.createElement('div'); ch.className = 'dw-hgc dw-l'; hgc.appendChild(ch); mount(ch, 'chakri', {seg: [60, 120], still: 100}); }

      // a little pop over the size someone picks
      $$('#sz button').forEach(function(b){ b.addEventListener('click', function(){ if (!b.classList.contains('oos')) pop(b.getBoundingClientRect(), 84) }) });
      // Add to cart: a rocket flies from the button to the bag and bursts there
      add.addEventListener('click', function(){ if (!RM && document.querySelector('#sz button.on:not(.oos)')) fly(add) });
    }
  }

  function pop(r, size){
    if (RM) return;
    var el = document.createElement('div'); el.className = 'dw-pop';
    el.style.width = size + 'px'; el.style.margin = (-size / 2) + 'px 0 0 ' + (-size / 2) + 'px';
    el.style.left = (r.left + r.width / 2) + 'px'; el.style.top = (r.top + r.height / 2) + 'px';
    document.body.appendChild(el);
    mount(el, 'pop', {loop: false, auto: false}).then(function(a){ a.play(); a.addEventListener('complete', function(){ el.remove() }); });
  }

  function fly(btn){
    var r = btn.getBoundingClientRect();
    var bag = [].slice.call(document.querySelectorAll('a[href="/cart"]')).map(function(a){ return a.getBoundingClientRect() }).filter(function(b){ return b.width && b.top >= 0 && b.top < innerHeight })[0];
    var x0 = r.left + r.width / 2, y0 = r.top, x1 = bag ? bag.left + bag.width / 2 : innerWidth - 30, y1 = bag ? bag.top + bag.height / 2 : 30;
    var cx = x0 + (x1 - x0) * .15 - 60, cy = Math.min(y0, y1) - 40;
    var el = document.createElement('div'); el.className = 'dw-fly'; document.body.appendChild(el);
    mount(el, 'rocketfly', {auto: false}).then(function(a){
      a.play();
      var K = [], N = 18, w = 36, h = 36 * 130 / 80;
      for (var i = 0; i <= N; i++){
        var t = i / N, u = 1 - t;
        var x = u * u * x0 + 2 * u * t * cx + t * t * x1, y = u * u * y0 + 2 * u * t * cy + t * t * y1;
        var dx = 2 * u * (cx - x0) + 2 * t * (x1 - cx), dy = 2 * u * (cy - y0) + 2 * t * (y1 - cy);
        var rot = Math.atan2(dx, -dy) * 180 / Math.PI, s = 1 - t * .45;
        K.push({transform: 'translate(' + (x - w / 2) + 'px,' + (y - h / 2) + 'px) rotate(' + rot + 'deg) scale(' + s + ')', offset: t});
      }
      var an = el.animate(K, {duration: 820, easing: 'cubic-bezier(.55,0,.6,1)', fill: 'forwards'});
      an.onfinish = function(){ el.remove(); pop({left: x1, top: y1, width: 0, height: 0}, 140); };
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();

// Diwali decor: skyshots that burst in empty space, marigold torans, akash kandils, fairy lights and rangolis.
// Everything here is pointer-events:none and sits at the edges of existing sections.
(function(){
  if (/[?&]diwali=off/.test(location.search)) return;
  if (window.HG_LANG === 'de') return;
  var RM = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var C = {mag: '#D6246E', mar: '#F28A1D', yel: '#F6C343', aub: '#3A1B33', pink: '#F28AA6', gold: '#E9B44C', leaf: '#3E8E5A', white: '#FFFFFF', cream: '#FFF3D6'};
  var uid = 0;

  var css = [
    '.dw-dec{position:absolute;pointer-events:none;z-index:1}',
    '.dw-dec svg{display:block;overflow:visible;width:100%;height:100%}',
    '.dw-dec svg *{transform-box:view-box}',
    '.dw-clip{overflow:hidden;overflow:clip;position:relative}',
    // kandil
    '.dw-kd{width:46px;height:108px;top:0}',
    '.dw-kd .sw{transform-origin:30px 0;animation:dwSwing 4.6s ease-in-out infinite alternate}',
    '.dw-kd .ts{animation:dwTass 1.8s ease-in-out infinite alternate}',
    '.dw-kd .gl{animation:dwGlow 2.4s ease-in-out infinite alternate}',
    '@keyframes dwSwing{from{transform:rotate(-5deg)}to{transform:rotate(5deg)}}',
    '@keyframes dwTass{from{transform:skewX(-6deg)}to{transform:skewX(6deg)}}',
    '@keyframes dwGlow{from{opacity:.45}to{opacity:1}}',
    // toran
    '.dw-tor{left:0;right:0;top:0;height:86px;z-index:3}',
    '.dw-tor .ladi{animation:dwSway 3.8s ease-in-out infinite alternate}',
    '@keyframes dwSway{from{transform:rotate(-4deg)}to{transform:rotate(4deg)}}',
    // fairy lights
    '.dw-lt{left:0;right:0;top:-4px;height:40px;z-index:2}',
    '.dw-lt .b{animation:dwTw 2.2s ease-in-out infinite alternate}',
    '@keyframes dwTw{from{opacity:1}to{opacity:.3}}',
    // rangoli
    '.dw-rg{aspect-ratio:1}',
    '.dw-rg .L{transform-origin:0 0;transition:transform 1.5s cubic-bezier(.2,.75,.34,.94),opacity .9s ease-out}',
    '.dw-rg:not(.on) .L{transform:scale(.3) rotate(-70deg);opacity:0}',
    '.dw-rg .spin{transform-origin:0 0}',
    '.dw-rg.on .spin{animation:dwSpin 80s linear infinite}',
    '@keyframes dwSpin{to{transform:rotate(360deg)}}',
    // border band
    '.dw-band{position:relative;height:34px;pointer-events:none;margin:0}',
    '.dw-band svg{display:block;width:100%;height:100%}',
    // buttons: a gold inner line, tiny rangoli corners and a twinkling star
    '.dw-bt{overflow:hidden}',
    '.dw-orn{position:absolute;inset:4px;border:1px solid rgba(233,180,76,.6);border-radius:inherit;pointer-events:none;background:var(--dw-c1) left -1px top -1px/16px 16px no-repeat,var(--dw-c2) right -1px bottom -1px/16px 16px no-repeat}',
    '.dw-bt.gh .dw-orn{border-style:dashed;border-color:rgba(201,154,59,.75)}',
    '.dw-tw{position:absolute;top:-3px;right:10%;width:9px;height:9px;pointer-events:none;background:var(--dw-st) center/contain no-repeat;animation:dwStar 2.8s ease-in-out infinite}',
    '@keyframes dwStar{0%,100%{transform:scale(.4) rotate(0);opacity:.3}50%{transform:scale(1) rotate(45deg);opacity:1}}',
    // skyshots
    '#dw-sky{position:fixed;left:0;top:0;pointer-events:none;z-index:2147482000}',
    '@media (prefers-reduced-motion:reduce){.dw-dec *,.dw-dec{animation:none!important;transition:none!important}.dw-rg .L{transform:none!important;opacity:1!important}}'
  ].join('\n');
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  // ---------- builders
  function star(cx, cy, R, r, n){ var p = []; for (var i = 0; i < n * 2; i++){ var a = Math.PI / n * i - Math.PI / 2, q = i % 2 ? r : R; p.push((cx + Math.cos(a) * q).toFixed(1) + ',' + (cy + Math.sin(a) * q).toFixed(1)); } return p.join(' '); }
  function kandil(pal){
    pal = pal || [C.mag, C.mar, C.yel];
    var t = '', cols = [C.gold, pal[0], pal[1], C.pink, C.gold, pal[0], pal[1]];
    for (var i = 0; i < 7; i++){ var x = 21 + i * 3, L = 30 + (i % 3) * 7 + (i === 3 ? 8 : 0); t += '<path class="ts" style="transform-origin:' + x + 'px 74px;animation-delay:' + (-i * .27) + 's" d="M' + x + ' 74 q2 ' + L / 2 + ' 0 ' + L + '" stroke="' + cols[i] + '" stroke-width="2" fill="none" stroke-linecap="round"/>'; }
    return '<svg viewBox="0 0 60 140"><g class="sw"><line x1="30" y1="0" x2="30" y2="26" stroke="' + C.aub + '" stroke-width="1.2"/>' +
      '<rect x="25.5" y="23" width="9" height="5" rx="1.5" fill="' + C.gold + '"/>' + t +
      '<circle class="gl" cx="30" cy="52" r="26" fill="' + C.yel + '" opacity=".35"/>' +
      '<polygon points="' + star(30, 52, 25, 12, 5) + '" fill="' + pal[0] + '" stroke="' + C.gold + '" stroke-width="1.2" stroke-linejoin="round"/>' +
      '<polygon points="' + star(30, 53, 15, 7.5, 5) + '" fill="' + pal[1] + '"/>' +
      '<circle class="gl" cx="30" cy="53" r="5.5" fill="' + C.cream + '"/></g></svg>';
  }
  function kd(host, side, off, pal, scale){
    var d = document.createElement('div'); d.className = 'dw-dec dw-kd'; d.setAttribute('aria-hidden', 'true');
    d.style[side] = (off || 14) + 'px'; if (scale) d.style.transform = 'scale(' + scale + ')', d.style.transformOrigin = '50% 0';
    d.innerHTML = kandil(pal); d.querySelector('.sw').style.animationDelay = (-Math.random() * 4) + 's';
    host.appendChild(d); return d;
  }
  function quad(a, c, b, t){ var u = 1 - t; return [u * u * a[0] + 2 * u * t * c[0] + t * t * b[0], u * u * a[1] + 2 * u * t * c[1] + t * t * b[1]]; }
  function marigold(x, y, r, i){
    var o = i % 2 ? [C.yel, '#E39A12'] : [C.mar, '#D45F0E'];
    return '<circle cx="' + x.toFixed(1) + '" cy="' + y.toFixed(1) + '" r="' + r + '" fill="' + o[0] + '"/><circle cx="' + x.toFixed(1) + '" cy="' + y.toFixed(1) + '" r="' + (r * .55).toFixed(1) + '" fill="' + o[1] + '"/>';
  }
  function leaf(x, y, a){ return '<path transform="translate(' + x.toFixed(1) + ' ' + y.toFixed(1) + ') rotate(' + a + ')" d="M0 0 q6 9 0 20 q-6 -11 0 -20z" fill="' + C.leaf + '"/>'; }
  function toranSVG(W){
    var n = Math.max(3, Math.round(W / 66)), w = W / n, g = '', top = 4;
    for (var s = 0; s < n; s++){
      var a = [s * w, top], b = [(s + 1) * w, top], c = [(s + .5) * w, top + 34];
      for (var k = 0, m = Math.round(w / 8.6); k <= m; k++){ var p = quad(a, c, b, k / m); g += marigold(p[0], p[1] + 2, 5.6, k + s); }
      var mx = (s + .5) * w, my = top + 19;
      g += leaf(mx - 3, my + 4, 18) + leaf(mx + 3, my + 4, -18);
    }
    var lad = '';
    for (var j = 0; j <= n; j++){
      var x = j * w, h = '';
      for (var q = 0; q < 4; q++) h += marigold(x, top + 9 + q * 10.5, 5, q + j);
      h += '<path d="M' + (x - 5) + ' ' + (top + 56) + ' q5 -9 10 0 z" fill="' + C.gold + '"/><circle cx="' + x + '" cy="' + (top + 58) + '" r="1.8" fill="' + C.gold + '"/>';
      lad += '<g class="ladi" style="transform-origin:' + x + 'px ' + top + 'px;animation-delay:' + (-j * .55) + 's">' + h + '</g>';
    }
    return '<svg viewBox="0 0 ' + W + ' 86" preserveAspectRatio="none"><line x1="0" y1="' + top + '" x2="' + W + '" y2="' + top + '" stroke="' + C.leaf + '" stroke-width="2.4"/>' + lad + g + '</svg>';
  }
  function lightsSVG(W){
    var n = Math.max(2, Math.round(W / 120)), w = W / n, d = '', b = '', cols = [C.yel, C.pink, C.mar, C.cream, C.mag], k = 0;
    for (var s = 0; s < n; s++){
      var a = [s * w, 4], e = [(s + 1) * w, 4], c = [(s + .5) * w, 30];
      d += 'M' + a[0] + ' ' + a[1] + ' Q' + c[0] + ' ' + c[1] + ' ' + e[0] + ' ' + e[1] + ' ';
      for (var t = 1; t < 6; t++){
        var p = quad(a, c, e, t / 6), col = cols[k % cols.length];
        b += '<g class="b" style="animation-delay:' + (-(k * .53) % 2.2).toFixed(2) + 's"><circle cx="' + p[0].toFixed(1) + '" cy="' + (p[1] + 6).toFixed(1) + '" r="7" fill="' + col + '" opacity=".3"/><circle cx="' + p[0].toFixed(1) + '" cy="' + (p[1] + 6).toFixed(1) + '" r="3.4" fill="' + col + '"/></g>' +
             '<rect x="' + (p[0] - 1.6).toFixed(1) + '" y="' + (p[1] + 1).toFixed(1) + '" width="3.2" height="3" fill="' + C.aub + '"/>';
        k++;
      }
    }
    return '<svg viewBox="0 0 ' + W + ' 40" preserveAspectRatio="none"><path d="' + d + '" stroke="#5B2C50" stroke-width="1.2" fill="none"/>' + b + '</svg>';
  }
  function petal(r1, r2, w){ var h = r2 - r1; return 'M0 ' + (-r1) + ' C' + w + ' ' + (-(r1 + h * .3)) + ' ' + (w * .5) + ' ' + (-(r2 - h * .08)) + ' 0 ' + (-r2) + ' C' + (-w * .5) + ' ' + (-(r2 - h * .08)) + ' ' + (-w) + ' ' + (-(r1 + h * .3)) + ' 0 ' + (-r1) + 'Z'; }
  function ring(n, r1, r2, w, fill, off, dot){
    var s = '';
    for (var i = 0; i < n; i++){ var a = 360 / n * i + (off || 0); s += '<path transform="rotate(' + a + ')" d="' + petal(r1, r2, w) + '" fill="' + (Array.isArray(fill) ? fill[i % fill.length] : fill) + '"/>'; if (dot) s += '<circle transform="rotate(' + a + ')" cx="0" cy="' + (-(r2 + 4)) + '" r="2" fill="' + dot + '"/>'; }
    return s;
  }
  function dots(n, r, rad, fill, off){ var s = ''; for (var i = 0; i < n; i++){ var a = (360 / n * i + (off || 0)) * Math.PI / 180; s += '<circle cx="' + (Math.cos(a) * r).toFixed(1) + '" cy="' + (Math.sin(a) * r).toFixed(1) + '" r="' + rad + '" fill="' + fill + '"/>'; } return s; }
  var PALS = [[C.mag, C.mar, C.yel, C.aub, C.pink], [C.mar, C.mag, C.pink, C.aub, C.yel], [C.aub, C.yel, C.mag, C.mar, C.pink]];
  function rangoliSVG(pi){
    var p = PALS[(pi || 0) % PALS.length], L = function(i, inner){ return '<g class="L" style="transition-delay:' + (i * .16) + 's">' + inner + '</g>'; };
    return '<svg viewBox="-100 -100 200 200">' +
      L(0, '<g class="spin">' + dots(40, 95, 2.2, p[3]) + ring(20, 72, 90, 9, p[0], 0, C.white) + '</g>') +
      L(1, '<circle r="72" fill="' + p[2] + '"/>' + ring(16, 50, 70, 10, [p[1], p[4]], 11.25)) +
      L(2, '<circle r="50" fill="' + C.white + '"/>' + ring(12, 28, 48, 9, p[0], 0) + dots(12, 47, 2.4, p[1], 15)) +
      L(3, '<circle r="28" fill="' + p[3] + '"/>' + ring(8, 8, 26, 7, p[2], 22.5) + '<circle r="7" fill="' + p[1] + '"/>' + dots(8, 16, 1.8, C.white)) + '</svg>';
  }
  var bloomIO = !RM && new IntersectionObserver(function(es){ es.forEach(function(e){ if (e.isIntersecting){ e.target.classList.add('on'); bloomIO.unobserve(e.target); } }); }, {threshold: .25});
  function rg(host, css, pal){
    var d = document.createElement('div'); d.className = 'dw-dec dw-rg' + (RM ? ' on' : ''); d.setAttribute('aria-hidden', 'true');
    d.style.cssText = css; d.innerHTML = rangoliSVG(pal); host.appendChild(d); if (bloomIO) bloomIO.observe(d); return d;
  }
  function bandSVG(){
    var id = 'dwb' + (++uid), t = 88;
    return '<svg aria-hidden="true"><defs><pattern id="' + id + '" width="' + t + '" height="34" patternUnits="userSpaceOnUse">' +
      '<g transform="translate(22 17)">' + ring(8, 2, 11, 4.2, C.mag) + '<circle r="3" fill="' + C.yel + '"/></g>' +
      '<g transform="translate(66 17)">' + ring(8, 2, 11, 4.2, C.mar) + '<circle r="3" fill="' + C.aub + '"/></g>' +
      '<circle cx="44" cy="17" r="2.2" fill="' + C.gold + '"/><circle cx="0" cy="17" r="2.2" fill="' + C.gold + '"/>' +
      dotsRow(t) + '</pattern></defs><rect width="100%" height="100%" fill="url(#' + id + ')"/></svg>';
  }
  function dotsRow(t){ var s = ''; for (var x = 2; x < t; x += 8) s += '<circle cx="' + x + '" cy="2" r="1.3" fill="' + C.gold + '"/><circle cx="' + (x + 4) + '" cy="32" r="1.3" fill="' + C.gold + '"/>'; return s; }
  function band(ref, where){ var d = document.createElement('div'); d.className = 'dw-band'; d.innerHTML = bandSVG(); ref.insertAdjacentElement(where || 'beforebegin', d); return d; }
  // width-driven decorations rebuild when their host resizes
  function sized(host, cls, build){
    var d = document.createElement('div'); d.className = 'dw-dec ' + cls; d.setAttribute('aria-hidden', 'true'); host.appendChild(d);
    var w0 = 0; function draw(){ var w = Math.round(d.getBoundingClientRect().width); if (w && Math.abs(w - w0) > 4){ w0 = w; d.innerHTML = build(w); } }
    draw(); if (window.ResizeObserver) new ResizeObserver(draw).observe(d); return d;
  }
  function pos(el){ if (getComputedStyle(el).position === 'static') el.style.position = 'relative'; }

  // ---------- placement
  function decorate(){
    var $ = function(s, r){ return (r || document).querySelector(s) };
    var hero = $('.hero'), gw = $('.gwrap');
    if (hero){
      var lu = $('.dw-lu');
      if (lu){ pos(lu); sized(lu, 'dw-lt', lightsSVG); kd(lu, 'right', 16, null); kd(lu, 'right', 70, [C.aub, C.mar, C.yel], .8);
        var stg = $('.dw-stage', lu); if (stg) rg(stg, 'left:50%;top:calc(100% - 46px);width:112%;transform:translate(-50%,-50%) scaleY(.34);z-index:0', 0); }
      var best = $('#bestsellers'); if (best) band(best);
      var shop = $('#shop'); if (shop){ pos(shop); sized(shop, 'dw-lt', lightsSVG); }
      var hts = $('.hts'); if (hts) band(hts);
      var sigs = $('.hsigs'); if (sigs){ pos(sigs); kd(sigs, 'right', 12, null, .9); kd(sigs, 'right', 60, [C.mar, C.mag, C.yel], .7); }
      var wine = $('.hwine'); if (wine) band(wine);
      var hcl = $('.hcl'); if (hcl){ pos(hcl); sized(hcl, 'dw-lt', lightsSVG); }
      var hrv = $('.hrv'); if (hrv){ pos(hrv); kd(hrv, 'left', 12, [C.aub, C.yel, C.mar], .85); kd(hrv, 'right', 12, null, .85); band(hrv); }
    }
    if (gw){
      var info = $('.info'); if (info){ pos(info); kd(info, 'right', 14, null, .92); }
      var hgc = $('.hgc-card'); if (hgc) band(hgc);
      var desc = $('.desc'); if (desc) band(desc);
    }
    var ft = $('footer.hf'); if (ft){ pos(ft); ft.classList.add('dw-clip'); sized(ft, 'dw-lt', lightsSVG); rg(ft, 'right:-120px;bottom:-120px;width:260px;opacity:.55', 0); }
    // pages without a hero or gallery still get lights under the header
    if (!hero && !gw){ var hh = $('.hh') || $('header'); if (hh){ var m = hh.nextElementSibling; if (m){ pos(m); sized(m, 'dw-lt', lightsSVG); } } }
    cart();
  }

  // ---------- cart drawer: toran under the header, diyas on the timer, rangoli behind "You may also like",
  // gold-trimmed checkout. The drawer re-renders its panel, so decorations go back on after every render.
  function cart(){
    var diya = svgUrl('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 2c2 3 2.6 5 0 8-2.6-3-2-5 0-8z" fill="#F6C343"/><path d="M12 5.5c.9 1.4 1 2.4 0 3.6-1-1.2-.9-2.2 0-3.6z" fill="#F28A1D"/><path d="M2 12h20c-.6 4.4-4.6 8-10 8S2.6 16.4 2 12z" fill="#E9B44C"/><path d="M5 14.5h14" stroke="#3A1B33" stroke-width=".8" stroke-dasharray="1.2 1.6"/></svg>');
    var rgUrl = svgUrl(rangoliSVG(1).replace('<svg ', '<svg xmlns="http://www.w3.org/2000/svg" '));
    var css = [
      '#hgcart .pn{background:linear-gradient(180deg,#FFFCF6 0%,#fff 38%)}',
      '#hgcart .pn .hd{display:flex!important;position:relative;inset:auto;visibility:visible;z-index:4;background:#FFFCF6}',
      '#hgcart .dw-ctor{position:absolute;left:0;right:0;top:100%;height:30px;pointer-events:none;z-index:5}',
      '#hgcart .pn .hd .dw-ctor svg{display:block;width:100%;height:100%;stroke:none;fill:none}',
      '#hgcart .dw-ctor .ladi{display:none}',
      '#hgcart .pn .tm{position:relative;padding-top:30px;background:radial-gradient(circle at 12% 60%,rgba(246,195,67,.22),transparent 40%),radial-gradient(circle at 88% 60%,rgba(246,195,67,.22),transparent 40%),#3A1B33;color:#FFF3D6}',
      '#hgcart .tm b{color:#F6C343}',
      '#hgcart .tm:before,#hgcart .tm:after{content:"";position:absolute;bottom:5px;width:20px;height:20px;background:' + diya + ' center/contain no-repeat;animation:dwFlick 1.6s ease-in-out infinite alternate}',
      '#hgcart .tm:before{left:16px}#hgcart .tm:after{right:16px;animation-delay:-.8s}',
      '@keyframes dwFlick{0%{transform:scale(1);filter:drop-shadow(0 0 2px #F6C343)}100%{transform:scale(1.08) translateY(-1px);filter:drop-shadow(0 0 6px #F28A1D)}}',
      '#hgcart .pn .ul{position:relative;overflow:hidden;background:#FFF6E6}',
      '#hgcart .ul:after{content:"";position:absolute;right:-64px;top:-64px;width:150px;height:150px;background:' + rgUrl + ' center/contain no-repeat;opacity:.16;pointer-events:none}',
      '#hgcart .ul>*{position:relative;z-index:1}',
      '#hgcart .pn .ft{position:relative;border-top:0}',
      '#hgcart .ft:before{content:"";position:absolute;left:0;right:0;top:0;height:4px;background:radial-gradient(circle,#E9B44C 1.3px,transparent 1.6px) 0 0/8px 4px repeat-x}',
      '#hgcart .dw-wish{text-align:center;font:400 12px/1 Jost,sans-serif;letter-spacing:.14em;text-transform:uppercase;color:#B07D2B;margin:2px 0 12px}',
      '#hgcart .go{position:relative;overflow:hidden}',
      '#hgcart .go .dw-orn{inset:5px}',
      '#hgcart .go:after{content:"";position:absolute;top:0;bottom:0;width:40%;left:-60%;background:linear-gradient(100deg,transparent,rgba(246,195,67,.35),transparent);animation:dwShine 3.4s ease-in-out infinite}',
      '@keyframes dwShine{0%,55%{left:-60%}100%{left:130%}}',
      '@media (prefers-reduced-motion:reduce){#hgcart .tm:before,#hgcart .tm:after,#hgcart .go:after{animation:none!important}}'
    ].join('\n');
    var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);
    function dress(pn){
      var hd = pn.querySelector('.hd');
      if (hd && !hd.querySelector('.dw-ctor')){
        var t = document.createElement('div'); t.className = 'dw-ctor'; t.setAttribute('aria-hidden', 'true');
        hd.appendChild(t); var w = Math.round(hd.getBoundingClientRect().width) || 400;
        // drawn 1.6x wide and cropped to the swags, so the marigolds stay round at 30px tall
        t.innerHTML = toranSVG(Math.round(w * 1.6)).replace(/viewBox="0 0 (\d+) 86" preserveAspectRatio="none"/, 'viewBox="0 0 $1 48"');
      }
      var go = pn.querySelector('.go[data-checkout]');
      if (go && !go.querySelector('.dw-orn')){
        var o = document.createElement('span'); o.className = 'dw-orn'; o.setAttribute('aria-hidden', 'true'); go.appendChild(o);
        var tw = document.createElement('span'); tw.className = 'dw-tw'; tw.setAttribute('aria-hidden', 'true'); o.appendChild(tw);
        if (!pn.querySelector('.dw-wish')){ var m = document.createElement('div'); m.className = 'dw-wish'; m.textContent = '✦ Wishing you a sparkling Diwali ✦'; go.parentNode.insertBefore(m, go); }
      }
    }
    function hook(){
      var pn = document.querySelector('#hgcart .pn'); if (!pn) return false;
      dress(pn); new MutationObserver(function(){ dress(pn); }).observe(pn, {childList: true});
      return true;
    }
    if (!hook()){ var mo = new MutationObserver(function(){ if (hook()) mo.disconnect(); }); mo.observe(document.body, {childList: true}); }
  }

  // ---------- skyshots
  function sky(){
    if (RM) return;
    var cv = document.createElement('canvas'); cv.id = 'dw-sky'; document.body.appendChild(cv);
    var ctx = cv.getContext('2d'), W, H, D = Math.min(2, devicePixelRatio || 1), P = [], S = [], F = [], run = false;
    // only rebuild for a real width change, not the mobile address bar showing or hiding mid-scroll
    function size(){ if (W === innerWidth && H >= innerHeight) return; H = W === innerWidth ? Math.max(H, innerHeight) : innerHeight; W = innerWidth; cv.width = W * D; cv.height = H * D; cv.style.width = W + 'px'; cv.style.height = H + 'px'; ctx.setTransform(D, 0, 0, D, 0, 0); }
    size(); addEventListener('resize', size);
    // no new skyshots while the page is moving: finding empty space forces layout and would stutter the scroll
    var lastS = 0; addEventListener('scroll', function(){ lastS = Date.now(); }, {passive: true});
    var BAD = 'img,video,picture,canvas,button,a,input,select,textarea,label,iframe,svg,.fpi,.gwrap,.thumbs,.hrail,.rail,.dw-ck,.dw-pickc,#hgcart,.hh,header,.bar,[role="dialog"]';
    function blank(x, y){
      if (!isFinite(x) || !isFinite(y)) return false;
      if (x < 4 || y < 4 || x > W - 4 || y > H - 4) return false;
      var el = document.elementFromPoint(x, y); if (!el || el === document.documentElement) return false;
      if (el.closest(BAD)) return false;
      for (var n = el.firstChild; n; n = n.nextSibling) if (n.nodeType === 3 && n.textContent.trim()) return false;
      var cs = getComputedStyle(el); if (cs.backgroundImage !== 'none' && !/gradient/.test(cs.backgroundImage)) return false;
      return true;
    }
    function spot(){
      var hb = (document.querySelector('.hh') || {getBoundingClientRect: function(){ return {bottom: 0} }}).getBoundingClientRect().bottom;
      for (var i = 0; i < 36; i++){
        var R = 62 + Math.random() * 58, x = R + 6 + Math.random() * (W - 2 * R - 12), y = Math.max(hb, 0) + R + 8 + Math.random() * Math.max(10, H * .78 - R - hb);
        var ok = blank(x, y);
        for (var k = 0; ok && k < 8; k++){ var a = k / 8 * Math.PI * 2, f = k % 2 ? .75 : .45; ok = blank(x + Math.cos(a) * R * f, y + Math.sin(a) * R * f); }
        if (ok) return [x, y, R];
      }
      return null;
    }
    var COLS = [['#D6246E', '#F6C343'], ['#F28A1D', '#FFD27A'], ['#E85D8C', '#F6C343'], ['#7B2E6B', '#E9B44C'], ['#E9B44C', '#F28A1D'], ['#C2185B', '#F28AA6']];
    function burst(x, y, R, type){
      var c = COLS[Math.random() * COLS.length | 0], n, i, a, v, drag;
      type = type || ['peony', 'peony', 'ring', 'willow', 'chrys'][Math.random() * 5 | 0];
      if (type === 'willow'){ c = ['#E9B44C', '#F28A1D']; drag = .975; n = 54; }
      else drag = .962;
      n = n || (type === 'ring' ? 56 : 96);
      for (i = 0; i < n; i++){
        a = type === 'ring' ? i / n * Math.PI * 2 : Math.random() * Math.PI * 2;
        v = R * (1 - drag) * (type === 'ring' ? 1 : .55 + Math.random() * .5);
        var life = type === 'willow' ? 105 + Math.random() * 30 : 64 + Math.random() * 26;
        P.push({x: x, y: y, px: x, py: y, vx: Math.cos(a) * v, vy: Math.sin(a) * v, d: drag, g: type === 'willow' ? .022 : .03, l: life, L: life,
                c: Math.random() < .22 ? c[1] : c[0], w: type === 'willow' ? 2.4 : 3.2, tw: type !== 'willow' && Math.random() < .5, cr: type === 'chrys'});
      }
      if (type === 'ring') for (i = 0; i < 18; i++){ a = Math.random() * Math.PI * 2; v = R * .45 * (1 - drag) * Math.random(); P.push({x: x, y: y, px: x, py: y, vx: Math.cos(a) * v, vy: Math.sin(a) * v, d: drag, g: .03, l: 40, L: 40, c: c[1], w: 2, tw: true}); }
      F.push({x: x, y: y, r: R * .9, l: 12, c: c[1]});
      // a gold glitter core that crackles after the main burst
      for (i = 0; i < 26; i++){ a = Math.random() * Math.PI * 2; v = R * .5 * (1 - drag) * Math.random(); P.push({x: x, y: y, px: x, py: y, vx: Math.cos(a) * v, vy: Math.sin(a) * v, d: .95, g: .015, l: 50 + Math.random() * 30, L: 80, c: '#E9B44C', w: 2, tw: true, dot: true}); }
      go();
    }
    function launch(){
      if (Date.now() - lastS < 900) return false;
      var s = spot(); if (!s) return false;
      var rise = Math.min(160, s[1] - 10);
      S.push({x: s[0] + (Math.random() - .5) * 24, y: s[1] + rise, tx: s[0], ty: s[1], R: s[2], t: 0, T: 34 + Math.random() * 10, y0: s[1] + rise, x0: 0});
      S[S.length - 1].x0 = S[S.length - 1].x;
      go(); return true;
    }
    function go(){ if (!run){ run = true; requestAnimationFrame(frame); } }
    function frame(){
      ctx.clearRect(0, 0, W, H); ctx.lineCap = 'round';
      S = S.filter(function(s){
        s.t++; var p = Math.min(1, s.t / s.T), e = 1 - Math.pow(1 - p, 2.2);
        var x = s.x0 + (s.tx - s.x0) * e, y = s.y0 + (s.ty - s.y0) * e;
        ctx.strokeStyle = 'rgba(233,180,76,.9)'; ctx.lineWidth = 2.2; ctx.beginPath(); ctx.moveTo(x, y); ctx.lineTo(x - (s.tx - s.x0) * .05, y + 16); ctx.stroke();
        for (var k = 0; k < 2; k++){ ctx.fillStyle = 'rgba(242,138,29,' + (.4 + Math.random() * .4) + ')'; ctx.beginPath(); ctx.arc(x + (Math.random() - .5) * 4, y + 10 + Math.random() * 14, 1.2, 0, 7); ctx.fill(); }
        if (p >= 1){ burst(s.tx, s.ty, s.R); return false; } return true;
      });
      F = F.filter(function(f){ f.l--; var g = ctx.createRadialGradient(f.x, f.y, 0, f.x, f.y, f.r); g.addColorStop(0, hexA(f.c, .38 * f.l / 12)); g.addColorStop(1, hexA(f.c, 0)); ctx.fillStyle = g; ctx.beginPath(); ctx.arc(f.x, f.y, f.r, 0, 7); ctx.fill(); return f.l > 0; });
      var keep = [];
      for (var i = 0; i < P.length; i++){
        var q = P[i]; q.px = q.x; q.py = q.y; q.vx *= q.d; q.vy = q.vy * q.d + q.g; q.x += q.vx; q.y += q.vy; q.l--;
        var al = Math.pow(q.l / q.L, .7); if (q.tw && q.l < q.L * .35) al *= Math.random() < .5 ? .15 : 1;
        ctx.strokeStyle = hexA(q.c, al); ctx.lineWidth = q.w;
        if (q.dot){ ctx.fillStyle = hexA(q.c, al); ctx.beginPath(); ctx.arc(q.x, q.y, 1.6, 0, 7); ctx.fill(); }
        else { ctx.beginPath(); ctx.moveTo(q.x - q.vx * (q.cr ? 6 : 4), q.y - q.vy * (q.cr ? 6 : 4)); ctx.lineTo(q.x, q.y); ctx.stroke(); ctx.fillStyle = hexA(q.c, al); ctx.beginPath(); ctx.arc(q.x, q.y, q.w * .75, 0, 7); ctx.fill(); }
        if (q.l > 0) keep.push(q);
      }
      P = keep;
      if (P.length || S.length || F.length) requestAnimationFrame(frame); else { run = false; ctx.clearRect(0, 0, W, H); }
    }
    var hx = {}; function hexA(h, a){ var v = hx[h] || (hx[h] = [parseInt(h.substr(1, 2), 16), parseInt(h.substr(3, 2), 16), parseInt(h.substr(5, 2), 16)]); return 'rgba(' + v[0] + ',' + v[1] + ',' + v[2] + ',' + a.toFixed(3) + ')'; }
    // a skyshot every few seconds, sometimes a volley of three
    function loop(){
      try { if (!document.hidden && !(document.querySelector('#hgcart.open'))){
        if (launch() && Math.random() < .3){ setTimeout(launch, 380); setTimeout(launch, 820); }
      } } catch (e) {}
      setTimeout(loop, 2400 + Math.random() * 2600);
    }
    setTimeout(function(){ launch(); setTimeout(launch, 500); setTimeout(loop, 1800); }, 1200);
    // tap any empty space to set one off
    window.HG_SKY = {launch: launch, burst: burst, spot: spot, blank: blank};
    document.addEventListener('click', function(e){ if (blank(e.clientX, e.clientY)) burst(e.clientX, e.clientY, 70 + Math.random() * 20); });
  }

  // ---------- buttons
  function svgUrl(x){ return 'url("data:image/svg+xml,' + encodeURIComponent(x) + '")'; }
  function corner(rot){ return svgUrl('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g transform="rotate(' + rot + ' 8 8)" fill="#E9B44C"><path d="M2 2 q5 1 6 6 q-5 -1 -6 -6z"/><circle cx="10.5" cy="2.6" r="1.1"/><circle cx="2.6" cy="10.5" r="1.1"/><circle cx="13.4" cy="2.4" r=".8"/><circle cx="2.4" cy="13.4" r=".8"/></g></svg>'); }
  function buttons(){
    var r = document.documentElement.style;
    r.setProperty('--dw-c1', corner(0)); r.setProperty('--dw-c2', corner(180));
    r.setProperty('--dw-st', svgUrl('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 10"><path d="M5 0 L6 4 L10 5 L6 6 L5 10 L4 6 L0 5 L4 4Z" fill="#E9B44C"/></svg>'));
    [].forEach.call(document.querySelectorAll('.h-btn, .hbtn, .hwcta, a.btn, .hgc-cta, .hf .nl button'), function(b, i){
      if (b.dataset.dw || b.offsetHeight < 34) return; b.dataset.dw = 1;
      var cs = getComputedStyle(b);
      if (cs.position === 'static') b.style.position = 'relative';
      b.classList.add('dw-bt'); if (/rgba\(0, 0, 0, 0\)|transparent/.test(cs.backgroundColor)) b.classList.add('gh');
      var o = document.createElement('span'); o.className = 'dw-orn'; o.setAttribute('aria-hidden', 'true'); b.appendChild(o);
      if (i % 2 === 0){ var t = document.createElement('span'); t.className = 'dw-tw'; t.setAttribute('aria-hidden', 'true'); t.style.animationDelay = (-i * .7) + 's'; o.appendChild(t); }
    });
  }

  function start(){ decorate(); buttons(); if (document.readyState === 'complete') sky(); else addEventListener('load', sky); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
